(function () {
  'use strict';

  angular.module('app').component('tourInventoryDetail', tourInventoryDetail());

  function tourInventoryDetail() {
    return {
      bindings: {
        item: '=',
        onInventorySaved: '&',
      },
      controller: TourInventoryDetailCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/tour-inventories/tour-inventory-detail/tour-inventory-detail.component.html',
    };
  }

  TourInventoryDetailCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$translate',
    '$filter',
    'moment',
    'TourInventoryService',
  ];

  function TourInventoryDetailCtrl(
    config,
    UtilService,
    $translate,
    $filter,
    moment,
    TourInventoryService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    vm.today = moment();

    vm.dateDisplay = config.DATE_DISPLAY;

    // Methods
    vm.saveInventory = saveInventory;

    vm.$onInit = function () {
      vm.item.from = '';
      vm.item.to = '';
      vm.item.total_availability = 0;

      setAvailabilityDates();

      vm.warningMsg = 'UPDATE_TOUR_INVENTORY_WARNING';

      if (vm.item.tour_option_id) {
        vm.warningMsg = 'UPDATE_TOUR_OPTION_INVENTORY_WARNING';
      }

      if (vm.item.tour_option_schedule_id) {
        vm.warningMsg = 'UPDATE_TOUR_OPTION_SCHEDULE_INVENTORY_WARNING';
      }
    };

    function setAvailabilityDates() {
      vm.optionsFrom = {
        singleDatePicker: true,
        showDropdowns: true,
        // autoUpdateInput:  false,
        minDate: moment(),
        locale: {
          format: vm.dateDisplay,
        },
        eventHandlers: {
          'apply.daterangepicker': function () {
            var startDate = angular.copy(vm.item.from);

            vm.optionsTo.minDate = startDate.add(1, 'days');
            if (vm.item.to && vm.item.to < vm.item.from) {
              vm.item.to = vm.optionsTo.minDate;
            }
          },
        },
      };

      vm.optionsTo = {
        singleDatePicker: true,
        showDropdowns: true,
        minDate: moment().add(1, 'days'),
        // autoUpdateInput:  false,
        locale: {
          format: vm.dateDisplay,
        },
      };
    }

    function saveInventory() {
      vm.item.startDay = timeZero(vm.item.from); // check utc
      vm.item.endDay = timeZero(vm.item.to); // ckeck utc

      vm.sendingForm = true;
      TourInventoryService.saveTourInventoriesByDates(vm.item).then(function () {
        vm.onInventorySaved();

        vm.sendingForm = false;
      });
    }

    // Set the time for date object into 00:00:00:00 without timezone offset
    function timeZero(date) {
      var m = date.utcOffset(0);
      m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      return m.toISOString();
    }
  }
})();
